export default "__VITE_ASSET__38f953b9__"